export enum GhostTemplates {
  ARTICLE_CARD = 'article-card',
  VARIATION_CARD = 'variation-card',
  TIP_CARD = 'tip-card'
}
